import {
  Avatar, Box, Button, Divider, Grid, IconButton, Menu, MenuItem, Select, Typography,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSSelectField from "../../../Components/Select/WSSelect";
import { useForm } from "react-hook-form";
import config from "../../../Config/clientConfig.json"
import { WSView } from "../../../Components/View/WSView";
import { callAPI, convertToUTCISOString, createObject, dateFormat, getLocalValue, LoacalVariables, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useParams } from "react-router-dom";
import WSBackButton from "../../../Components/BackButton/BackButton";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { EmailDrawyer } from "../../Emails/EmailDrawyer";
import CallDrawyer from "./DrawyerPages/CallDrawyer";
import TaskDrawyer from "./DrawyerPages/TaskDrawyer";
import { useDispatch } from "react-redux";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import { ICall, IMeeting, ITask } from "../../DTO/Dto";
import dayjs from "dayjs";
import DealsDrawyer from "../../Deals/DealsDrawyer";
import MeetingDrawyer from "./DrawyerPages/MeetingDrawyer";
import DrawyerNote from "../../Notes/DrawyerNote";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
const ContactCard: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const data = props?.data;
  const topLableFontSize = '0.875rem'
  const topDataFontSize = '0.75rem'
  const [open, setOpen] = React.useState(false);
  const [callOpen, setCallOpen] = React.useState(false);
  const [taskOpen, setTaskOpen] = React.useState(false);
  const [meetingOpen, setMeetingOpen] = React.useState(false);
  const [dealOpen, setDealOpen] = React.useState(false);
  const [noteOpen, setNoteOpen] = React.useState(false);
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const id = params?.id;
  const handleEmail = async (data: any) => {
    AllPermissions.getInstance();
    try {
      if (data) {
        dispatch(storeDataComponent('emailSubmit', { loading: true }));
        const response = await createObject('email/send', { toEmail: data?.toEmail, subject: data.subject, body: data.body, leadId: id })
        dispatch(storeDataComponent('emailSubmit', { loading: false }));
        if (response && response?.message) {
          dispatch(resetDataComponent('emailContactDataGrid'));
          showMessage(response.message, response.success === true ? 'success' : 'error')
        } else if (response?.id) {

          showMessage('Mail sent successfully', 'success')
        }
      }
    }
    catch (e) { }
    finally {

    }
  }
  const handleCallData = async (data: any) => {
    try {
      dispatch(storeDataComponent('callSubmit', { loading: true }));
      const response: any = await saveData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent('callLogContactGrid'));
        reset()
        //  setResetLoad(true)
        showMessage(response.message, response.success === true ? 'success' : 'error')
      } else if (response?.id) {
        dispatch(resetDataComponent('callLogContactGrid'));
        // setResetLoad(true)
        showMessage('Deals Created Successfully', 'success')
      }
    } catch (e: any) {
      showMessage(e.error);
      //   setResetLoad(true)
    }
    finally {
      dispatch(updateDataComponent('callSubmit', { loading: false }));
    }

  }
  const saveData = async (data: ICall) => {
    const callStart: any = convertToUTCISOString(data?.callStart.toString());
    const request: ICall = {
      callType: data?.callType || "",
      callStart: callStart || "",
      callDuration: Number(data.callDuration) || 0,
      callPurpose: data?.callPurpose || "",
      leadId: id || "",
      callResult: data.callResult || "",
      description: data.description,
      subject: data?.subject || "",
      callStatus: data?.callStatus
    }
    if (data?.callId) {
      const response: any = await callAPI("call-logs", Method.PUT, request, data.callId);
      return response
    } else {
      const response: any = await callAPI("call-logs", Method.POST, request);
      return response
    }

  }


  const handleTasksData = async (data: any) => {
    try {
      dispatch(storeDataComponent('taskSubmit', { loading: true }));
      const response: any = await saveTaskData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent('contactTaskGrid'));
        reset()
        //  setResetLoad(true)
        showMessage(response.message, response.success === true ? 'success' : 'error')
      } else if (response?.id) {
        dispatch(resetDataComponent('contactTaskGrid'));
        //  setResetLoad(true)
        showMessage('Task Created Successfully', 'success')
      }
    } catch (e: any) {
      showMessage(e.error);
      //  setResetLoad(true)
    }
    finally {
      dispatch(updateDataComponent('taskSubmit', { loading: false }));
    }
  }
  const saveTaskData = async (data: ITask) => {
    const isoString: any = dayjs(`${data?.customDate} 00:00`, "DD-MM-YYYY HH:mm").toISOString();
    const request: ITask = {
      taskName: data?.taskName || "",
      activityDate: data?.activityDate?.toString() || "",
      activityTime: data?.activityTime || "",
      customDate: isoString || "",
      assignedToUserId: data?.assignedToUserId || getLocalValue(LoacalVariables.UserId),
      leadId: id || "",
      customReminderTime: data.customReminderTime,
      notes: data?.notes || "",
      priority: data?.priority || "",
      queue: data?.queue || "",
      reminder: data?.reminder?.toString() || "",
      reminderSent: data?.reminderSent || false,
      taskType: data?.taskType || "",

    }
    if (data?.taskId) {
      const response: any = await callAPI("tasks", Method.PUT, request, data?.taskId);
      return response
    } else {
      const response: any = await callAPI("tasks", Method.POST, request);
      return response
    }

  }
  const handleIconClick = (index: number) => {
    switch (index) {
      case 1:
        setTimeout(() => {
          setOpen(true)
        }, 100);

        break
      case 2:
        setTimeout(() => {
          setCallOpen(true)
        }, 10);

        break
      case 3:
        setTaskOpen(true)
        break
      case 4:
        setMeetingOpen(true)
        break
      case 5:
        setDealOpen(true)
        break
      case 6:
        setNoteOpen(true)
        break
    }
  }
  const handlemeetingsData = async (data: any) => {
    try {
      dispatch(storeDataComponent('meetingSubmit', { loading: true }));
      const response: any = await saveMeetingData(data);

      if (response && response?.message) {
        dispatch(resetDataComponent('meetingContactGrid'));
        reset()
        // setResetLoad(true)
        showMessage(response.message, response.success === true ? 'success' : 'error')
      } else if (response?.id) {
        dispatch(resetDataComponent('meetingContactGrid'));
        // setResetLoad(true)
        showMessage('Deals Created Successfully', 'success')
      }
    } catch (e: any) {
      showMessage(e.error);
      // setResetLoad(true)
    }
    finally {
      dispatch(updateDataComponent('meetingSubmit', { loading: false }));
    }

  }
  const saveMeetingData = async (data: IMeeting) => {
    const startDate: any = convertToUTCISOString(data?.startDateTime.toString())
    const endDate: any = convertToUTCISOString(data?.endDateTime.toString())
    const valuesArray = data?.participantIds.map((participant: any) => participant.value);
    const request: IMeeting = {
      title: data?.title || "",
      startDateTime: startDate || "",
      endDateTime: endDate || "",
      hostUserId: getLocalValue(LoacalVariables.UserId),//data?.assignedToUserId || getLocalValue(LoacalVariables.UserId) ,
      leadId: id || "",
      participantIds: valuesArray,
      customReminderTime: data.customReminderTime,
      notes: data?.notes || "",
      dealId: data?.dealId || "",
      meetingType: data?.meetingType || "",
      reminderOption: data?.reminderOption?.toString()

    }

    if (data?.meetingId) {
      const response: any = await callAPI("meetings", Method.PUT, request, data?.meetingId);
      return response
    } else {
      const response: any = await callAPI("meetings", Method.POST, request);
      return response
    }

  }

  const handleDealsData = async (data: any) => {
    try {
      dispatch(storeDataComponent('dealSubmit', { loading: true }));
      const response: any = await saveDealsData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent('leadContactDealsGrid'));
        reset()
        showMessage(response.message, response.success === true ? 'success' : 'error')
      } else if (response?.id) {
        dispatch(resetDataComponent('leadContactDealsGrid'));
        showMessage('Deals Created Successfully', 'success')
      }
    } catch (e: any) {
      showMessage(e.error);
    }
    finally {
      dispatch(updateDataComponent('dealSubmit', { loading: false }));
    }

  }
  const saveDealsData = async (data: any) => {
    const formattedDateTime: any = dayjs(`${data?.closeDate} 00:00`, "DD-MM-YYYY HH:mm").toISOString();
    const request: any = {
      "dealName": data?.dealName || "",
      "amount": Number(data?.amount) || "",
      "stage": data?.stage || "",
      "status": data?.status || "",
      "closeDate": formattedDateTime || "",
      "leadId": id || "",
      "dealOwner": getLocalValue(LoacalVariables.UserId),
      "customerType": data?.customerType || "",
      "nextStep": data?.nextStep || "",
      "source": data?.source || "",
      "profitability": Number(data?.profitability) || 0,
      "expectedRevenue": Number(data?.expectedRevenue) || 0,
      "campaignSource": data?.campaignSource || "",
      "notes": data?.notes || "",
    }
    if (data?.dealId) {
      const response: any = await callAPI("deals", Method.PATCH, request, data?.dealId);
      return response
    } else {
      const response: any = await callAPI("deals", Method.POST, request);
      return response
    }

  }
  const handleNoteData = async (data: any) => {
    try {
      if (data?.content && id) {
        dispatch(storeDataComponent('noteSubmit', { loading: true }));
        const response = await createObject('notes', { content: data?.content, leadId: id })
        if (response && response?.message) {
          dispatch(resetDataComponent('contactNotesGrid'));
          reset()
          showMessage(response.message, response.success === true ? 'success' : 'error')
        } else if (response?.id) {
          dispatch(resetDataComponent('contactNotesGrid'));
          showMessage('Notes Created Successfully', 'success')
        }
      }
    }
    catch (e) { }
    finally {
      dispatch(updateDataComponent('noteSubmit', { loading: false }));
    }
  }

  return (
    <Grid
      sx={{ backgroundColor: "white", borderRadius: 2, p: 2, boxShadow: 1, mt: 2 }}
    >
      <Grid
        item
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={8} sx={{ display: "flex", alignItems: "center" }}>
          <Avatar src="/profile.jpg" sx={{ width: 50, height: 50, mr: 2 }} />
          <Grid>
            <Typography fontWeight="bold" sx={{ color: "#7D79C2", fontSize: '1rem' }}>
              {`${data?.firstName} ${data?.lastName || ''}`}
            </Typography>
            <Typography color="textSecondary">  {`${data?.email || ''} `}</Typography>
          </Grid>
        </Grid>


        {/* Actions Button & Icons */}
        <Grid item xs={12} sm={4} sx={{ display: "flex", alignItems: "end", gap: 2, justifyContent: '' }}>
          {[
            <WSBackButton sx={{ width: 20 }} id="btnLeadEditback" url="/contacts/list" />,
            AllPermissions.getEmailPermission.add ? <WSIcons.EmailIcon sx={{ width: 20 }} /> : undefined,
            AllPermissions.getCallPermission.add ? <WSIcons.PhoneIcon sx={{ width: 20 }} /> : undefined,
            AllPermissions.getTaskPermission.add ? <WSIcons.TaskIconNew sx={{ width: 20 }} /> : undefined,
            AllPermissions.getMeetingPermission.add ? <WSIcons.ScheduleIcon sx={{ width: 20 }} /> : undefined,
            AllPermissions.getDealPermission.add ? <WSIcons.DealIcon sx={{ width: 20 }} /> : undefined,
            AllPermissions.getNotesPermission.add ? <WSIcons.NoteIcon sx={{ width: 20 }} /> : undefined
          ].filter(Boolean).map((icon, index) => (<>
            <IconButton
              key={index}
              onClick={(e) => { handleIconClick(index) }}
              sx={{
                width: 30,
                height: 30,
                bgcolor: "#f0f0f0",
                border: "1px solid #ccc",
                borderRadius: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {icon}
            </IconButton>
          </>
          ))}
        </Grid>
      </Grid>

      <Grid sx={{ border: "1px solid #ddd", borderRadius: 1, p: 2, mt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <Typography sx={{ fontSize: topLableFontSize }}>Email</Typography>
            <Typography sx={{ fontSize: topDataFontSize }} color="textSecondary" noWrap={false}>
              {`${data?.email || ''} `}
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mt: 2 }} />

          <Grid item xs={12} sm={2}>
            <Typography sx={{ fontSize: topLableFontSize }}>Mobile</Typography>
            <Typography sx={{ fontSize: topDataFontSize }} color="textSecondary">
              {`${data?.mobile || ''} `}
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mt: 2 }} />
          <Grid item xs={12} sm={2}>
            <Typography sx={{ fontSize: topLableFontSize }}>Company</Typography>
            <Typography sx={{ fontSize: topDataFontSize }} color="textSecondary">
              {`${data?.company || ''} `}
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mt: 2 }} />
          <Grid item xs={12} sm={2}>
            <Typography sx={{ fontSize: topLableFontSize }}>Lead Status</Typography>
            <Typography sx={{ fontSize: topDataFontSize }} color="textSecondary">
              New
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mt: 2 }} />
          <Grid item xs={12} sm={3}>
            <Typography sx={{ fontSize: topLableFontSize }}>Created On</Typography>
            <Typography sx={{ fontSize: topDataFontSize }} color="textSecondary">
              {`${dateFormat(data?.createdAt, "DD/MM/YYYY") || ''} `}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <SwipeableDrawerForm anchor="right" title={'Send Email'}
        openForm={open}
        formComponent={open && <form onSubmit={handleSubmit(handleEmail)}>
          <EmailDrawyer
            id="leadEmail"
            control={control}
            register={register}
            reset={reset}
            setValue={setValue}
            onCancel={() => { reset(); setOpen(false) }}
          />
        </form>}
        onClose={() => { reset(); setOpen(false) }}

      />
      <SwipeableDrawerForm anchor="right" title={'Meeting'}
        openForm={meetingOpen}
        formComponent={meetingOpen && <form onSubmit={handleSubmit(handlemeetingsData)}>
          <MeetingDrawyer
            id="meetings"
            control={control}
            register={register}
            reset={reset}
            setValue={setValue}
            onCancel={() => { reset(); setMeetingOpen(false) }}
          />

        </form>}
        onClose={() => { reset(); setMeetingOpen(false) }}

      />
      <SwipeableDrawerForm anchor="right" title={'Call Log'}
        openForm={callOpen}
        formComponent={callOpen && <form onSubmit={handleSubmit(handleCallData)}>
          <CallDrawyer
            id="calllog"
            control={control}
            register={register}
            reset={reset}
            setValue={setValue}
            onCancel={() => { reset(); setCallOpen(false) }}
          />
        </form>}
        onClose={() => { reset(); setCallOpen(false) }}

      />
      <SwipeableDrawerForm anchor="right" title={'Task'}
        openForm={taskOpen}
        formComponent={taskOpen && <form onSubmit={handleSubmit(handleTasksData)}>
          <TaskDrawyer loading
            id="tasks"
            control={control}
            register={register}
            reset={reset}
            setValue={setValue}
            onCancel={() => { reset(); setTaskOpen(false) }}
          />
        </form>}
        onClose={() => { reset(); setTaskOpen(false) }}

      />
      <SwipeableDrawerForm anchor="right" title={'Deals'}
        openForm={dealOpen}
        formComponent={dealOpen && <form onSubmit={handleSubmit(handleDealsData)}>
          <DealsDrawyer
            id="dealaddedit"
            control={control}
            register={register}
            reset={reset}
            setValue={setValue}
            onCancel={() => { reset(); setDealOpen(false) }}
          />

        </form>}
        onClose={() => { reset(); setDealOpen(false) }}

      />
      <SwipeableDrawerForm anchor="right" title={'Notes'}
        openForm={noteOpen}
        formComponent={noteOpen && <form onSubmit={handleSubmit(handleNoteData)}>
          <DrawyerNote
            id="noteaddeditcontact"
            control={control}
            register={register}
            reset={reset}
            setValue={setValue}
            onCancel={() => { reset(); setNoteOpen(false) }}
          />
        </form>}
        onClose={() => { reset(); setNoteOpen(false) }}

      />
    </Grid>
  );
})

export default ContactCard;
